import { useEditCanvasStore } from '../../store';
import { isImageNode, isVideoNode } from '../../utils/typeGuards';
import { getNodeData } from './getNodeData';

/**
 * Syncs a media node (image or video) to the server.
 * Only sends an update if the node has already been persisted (has a remoteId).
 */
export function syncMediaNode(nodeId: string) {
  const node = useEditCanvasStore.getState().nodes.find((n) => n.id === nodeId);

  if (!isImageNode(node) && !isVideoNode(node)) {
    return;
  }

  if (!node.remoteId) {
    return;
  }

  const nodeData = getNodeData(node);

  if (!nodeData) {
    return;
  }

  useEditCanvasStore.getState().updateNodes?.([{ data: nodeData.data, id: nodeId }]);
}
